import React, { useEffect, useState } from 'react';
import { PayPalButton } from 'react-paypal-button-v2';
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-bootstrap';

const RenewalPaypalThirdParty = ({ parkingamount, orderId, parkingplan }) => {
  const authKey = sessionStorage.getItem('authorid');
    
  const onCancel = (data) => {
    // Handle payment cancellation
    console.log('Payment cancelled', data);
  };

  const onError = (err) => {
    // Handle errors
    console.error('Error during payment', err);
  };

  const PortingtoAPI = async (authorid, orderId, parkingplan, parkingamount) => {
    try {
      const url = 'https://vanityapi.adef.tech/NumberBarn/ParkingForThirdParty';
      const requestData = {
        authorid,
        phonenumber: orderId,
        parkingplan,
        parkingamount
      };

      const data = new URLSearchParams(requestData);

      const response = await fetch(url, {
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        if (responseData.responseCode === 1) {
          const showSuccessToast = () => {
            
            toast.success(responseData.responsemessage, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              onClose: () => {
                window.location.reload();
              },
            });
          };
          showSuccessToast();
        } else {
          const showErrorToast = () => {
            toast.error(responseData.responsemessage, {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          };
          showErrorToast();
          console.error('Renewal  failed:', responseData.responsemessage);
        }
      } else {
        console.error('Server error:', response.statusText);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <div className='d-flex justify-content-center py-5'>
        <PayPalButton
          amount={parkingamount}
          onSuccess={(details, data) => {
            // Include requestData in the options
            PortingtoAPI(authKey, orderId, parkingplan, parkingamount);
          }}
          onCancel={onCancel}
          onError={onError}
          options={{
            // live
            clientId: 'ARkAwgblSGgWAqLmFzq26yZmFXd8YgJK4ep0BFaxnQxWzG-hwJGpE3zIbBeuX6HXePQFzl-sgscUh5nK',
            // test
            // clientId: "AX-ROSkCxK1W1uwSJFxl2nwe5Q2TJMmmYYZNnhHXSEDO7cgh8CvogLUirE1um46FrTMYcdxjMQEqe3VM",
            currency: 'USD',
            custom: JSON.stringify({
              authorid: authKey,
              phonenumber: orderId,
              parkingplan:parkingplan
            }),
          }}
        />
      </div>
      <ToastContainer></ToastContainer>
    </>
  );
};

export default RenewalPaypalThirdParty;
